import { Box, Grid, CircularProgress, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
import { isEmpty } from 'lodash-es';
import { FC, useCallback, useEffect, useState } from 'react';
import {
  getAllInteractions,
  getCandidateSubmissionSettingsTemplate,
  ISubmissionSettingsResponse,
  IJob,
  IJobCandidateInteractionResponse,
  IMappingFormSettingsResponse,
} from 'wisestep-api';
import {
  WsColors,
  WsDrawer,
  IConversationState,
  Item,
  WsTypography,
  WsTypoVariants,
  WsTypoColors,
  ICandidateAggregatedData,
  IUserDTO,
} from 'wisestep-base';

import BulkEmail from '../../../components/BulkEmail';
import { SMSChatBox } from '../../../components/SMS';
import SuccessMessageLayout from '../../../components/SuccessMessageLayout';
import { WsTaskCreationCard } from '../../../components/WsTaskCreationCard';
import { useUserContext, useWorkspaceContext } from '../../../context';
import { CandidateViewData } from '../../../features/candidateLayout/utils/CandidateViewContext';
import {
  amplitudeEventJobCrmPipelineApplicationsEmailSuccessFail,
  amplitudeEventJobCrmPipelineApplicationsPhoneSuccessFail,
  amplitudeEventJobCrmPipelineMappingEmailSuccessFail,
  amplitudeEventJobCrmPipelineMappingsPhoneSuccessFail,
  amplitudeEventJobCrmPipelineSubmissionsEmailSuccessFail,
  amplitudeEventJobCrmPipelineSubmissionsPhoneSuccessFail,
  amplitudeEventJobCrmPipelineUploadedEmailSuccessFail,
  amplitudeEventJobCrmPipelineUploadedPhoneSuccessFail,
  amplitudeEventJobCrmSmartSourceAiEmailSuccessFail,
  amplitudeEventJobCrmSmartSourceAiPhoneSuccessFail,
  amplitudeEventJobCrmSmartSourceSimilarJobsEmailSuccessFail,
  amplitudeEventJobCrmSmartSourceSimilarJobsPhoneSuccessFail,
  amplitudeJobCrmUrl,
} from '../../../features/jobsCrm/utils/AmplitudeEvents';
import { warning } from '../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../utils/NotificationStore';
import { useConversationWidgetStore } from '../../../utils/useConversationWidgetStore';
import { getAllTeamsOfCurrentUser } from '../../jobs/helper';

import useMappingFormSettings from './../../../hooks/useMappingFormSettings';
// import MappingForm from './MappingForm';
import MappingFormNew from './MappingFormNew';
import RecruiterQuestionForm from './RecruiterQuestionForm';
import SendRtrComponent from './SendRtrComponent';
import ShareCandidateOverlay from './ShareCandidateOverlay';
import SubmissionForm from './SubmissionForm';
// import WidgetDrawerNavigation from './WidgetDrawerNavigation';
import WidgetDrawerNavigationNew from './WidgetDrawerNavigationNew';

interface IConversationWidgetDrawer {
  open: boolean;
  state: IConversationState;
  recruiterAction: string | null;
  closeDrawer: () => void;
  selectedJob?: IJob | null;
  updateMapping?: boolean;
  submitCandidate?: boolean;
  submissionPurpose: string;
  aggregation: ICandidateAggregatedData | null;
  isLayout?: boolean;
  closeMap?: () => void;
  candidateViewData?: CandidateViewData | null;
  mappingPurpose?: string;
}

const GridItem = styled(Grid)(() => ({
  height: '100vh',
  overflowY: 'auto',
}));

const ConversationWidgetDrawer: FC<IConversationWidgetDrawer> = ({
  open,
  state,
  recruiterAction,
  closeDrawer,
  selectedJob,
  updateMapping = false,
  submitCandidate = false,
  submissionPurpose,
  aggregation,
  closeMap,
  isLayout,
  candidateViewData,
  mappingPurpose,
}) => {
  const [isMapped, setIsMapped] = useState<boolean>(false);
  const [isRecentInteractionWithCurrentJob, setRecentInteractionWithCurrentJob] =
    useState<boolean>(false);
  const [submissionSetting, setSubmissionSetting] = useState<ISubmissionSettingsResponse | null>(
    null
  );
  const { id: workspaceId } = useWorkspaceContext();
  const mappingFormSettingsResponse = useMappingFormSettings();
  const [mappingFormSettings, setMappingFormSetings] = useState<
    IMappingFormSettingsResponse | undefined
  >();
  const onCandidateUpdate = useConversationWidgetStore((state) => state.onCandidateUpdate);
  const tempConv = useConversationWidgetStore((state) => state.tempConv);
  const [tabIndex, setTabIndex] = useState<number>(3);
  const [defaultIndex, setDefaultIndex] = useState<number>(3);
  const [loader, setLoader] = useState<boolean>(false);
  const [openDrawer, setOpenDrawer] = useState<boolean>(false);
  const widgetCandidate = useConversationWidgetStore((state) => state.candidate);
  const fromPage = useConversationWidgetStore((state) => state.fromPage);
  const action = useConversationWidgetStore((state) => state.action);
  const updateAction = useConversationWidgetStore((state) => state.updateAction);
  const selectedEmail = useConversationWidgetStore((state) => state.selectedEmail);
  const selectedPhoneNumber = useConversationWidgetStore((state) => state.selectedPhoneNumber);
  const activityConversation = useConversationWidgetStore((state) => state.activityConversation);
  const setActivityConversationFor = useConversationWidgetStore(
    (state) => state.setActivityConversationFor
  );
  const [activity, setActivity] = useState<IJobCandidateInteractionResponse[]>();
  const [questionAnswer, setQuestionAnswer] = useState<any>([]);
  // const updateCandidate = useConversationWidgetStore((state) => state.onCandidateUpdate);
  const updateActivityConversation = useConversationWidgetStore(
    (state) => state.updateActivityConversation
  );
  const [successMessage, setMessage] = useState<string>('');
  const [isPartOfTeam, setIsPartOfTeam] = useState<boolean>();
  const setNotification = useNotificationStore((state) => state.setNotification);

  state.candidate.passportNumber = isEmpty(state.candidate.passportNumber)
    ? aggregation?.candidateEntity?.passportNumber ?? ''
    : state.candidate.passportNumber;

  state.candidate.passportType = isEmpty(state.candidate.passportType)
    ? aggregation?.candidateEntity?.passportType ?? ''
    : state.candidate.passportType;
  state.candidate.dob = !state?.candidate?.dob
    ? aggregation?.candidateEntity?.dob
    : state.candidate.dob;

  state.candidate.gender = isEmpty(state.candidate.gender)
    ? aggregation?.candidateEntity?.gender
    : state.candidate.gender;

  state.candidate.age = isEmpty(state.candidate.age)
    ? aggregation?.candidateEntity?.age ?? ''
    : state.candidate.age;

  state.candidate.postalAddress = isEmpty(state.candidate.postalAddress)
    ? aggregation?.candidateEntity?.postalAddress ?? ''
    : state.candidate.postalAddress;

  state.candidate.ssnNumber = isEmpty(state.candidate.ssnNumber)
    ? aggregation?.candidateEntity?.ssnNumber ?? ''
    : state.candidate.ssnNumber;

  state.candidate.panCard = isEmpty(state.candidate.panCard)
    ? aggregation?.candidateEntity?.panCard ?? ''
    : state.candidate.panCard;

  state.candidate.aadharNumber = isEmpty(state.candidate.aadharNumber)
    ? aggregation?.candidateEntity?.aadharNumber ?? ''
    : state.candidate.aadharNumber;

  const setSubmissionSettings = useCallback(async () => {
    try {
      const setting = await getCandidateSubmissionSettingsTemplate(
        selectedJob?.submissionFormTemplete ?? '',
        workspaceId ?? ''
      );
      setSubmissionSetting(setting?.data?.fields);
    } catch (error) {
      console.error('Error fetching submission settings:', error);
      setNotification(warning('Submisison setting API is failed'));
      setSubmissionSetting(null);
    }
  }, [selectedJob?.submissionFormTemplete, workspaceId]);

  const openTab = (value: number) => {
    setDefaultIndex(value);
    setTabIndex(value);
    setOpenDrawer(true);
  };
  useEffect(() => {
    const findAllInteractions = async () => {
      const res = await getAllInteractions(state.candidate.candidateId ?? '');
      if (res.data) {
        setActivity(res.data.filter((item) => item.id === state.candidate.candidateId));
        setIsMapped(res.data.some((item) => item.jobCode === selectedJob?.jobCode));
      }
    };
    findAllInteractions();
  }, [state]);
  useEffect(() => {
    const isAggregationJobCodeMatch: boolean =
      (selectedJob &&
        activity?.some(
          (interaction) =>
            interaction.jobCode === selectedJob?.jobCode || interaction?.questionResponse
        )) ??
      false;
    const isCandidateViewdataJobCodeMatch: boolean =
      (candidateViewData &&
        selectedJob &&
        candidateViewData?.aggregationData?.recentInteractions?.some(
          (interaction) => interaction?.jobCode === selectedJob?.jobCode
        )) ??
      false;
    setRecentInteractionWithCurrentJob(
      isAggregationJobCodeMatch || isCandidateViewdataJobCodeMatch
    );
    setQuestionAnswer(activity?.at(0)?.questionResponse);
  }, [aggregation, selectedJob, candidateViewData, activity, state.candidate.candidateId]);
  const loggedInUser = useUserContext().userDTO as IUserDTO;
  useEffect(() => {
    if (activityConversation && activityConversation.candidateStatusTags && !action) {
      switch (activityConversation.candidateStatusTags[0]) {
        case 'mapped':
          setActivityConversationFor('mapping');
          setDefaultIndex(0);
          setTabIndex(0);
          setMessage('');
          setOpenDrawer(true);
          break;
        case 'submitted':
          setActivityConversationFor('submission');
          setDefaultIndex(5);
          setTabIndex(5);
          setSubmissionSettings();
          setMessage('');
          setOpenDrawer(true);
          break;
        case 'uploaded':
          setDefaultIndex(3);
          setTabIndex(3);
          setMessage('');
          setOpenDrawer(true);
          break;
        case 'applied':
          setDefaultIndex(3);
          setTabIndex(3);
          setMessage('');
          setOpenDrawer(true);
          break;
      }
    } else if (action) {
      switch (action) {
        case 'sms':
          openTab(4);
          break;
        case 'email':
          openTab(3);
          break;
        case 'call':
          openTab(5);
          break;
        case 'mapping':
          openTab(0);
          break;
        case 'task':
          openTab(6);
          break;
        case 'rtr':
          openTab(7);
          break;
        case 'submission':
          openTab(8);
          setSubmissionSettings();
          break;
        case 'smslogs':
          openTab(0);
          break;
        case 'share':
          openTab(2);
          break;
        case 'question':
          openTab(1);
          break;
      }
    }
  }, [activityConversation, action, setActivityConversationFor]);

  useEffect(() => {
    if (submitCandidate) {
      setDefaultIndex(8);
      setTabIndex(8);
      setSubmissionSettings();
    } else if (updateMapping) {
      setDefaultIndex(0);
      setTabIndex(0);
    }
    setMessage('');
    setOpenDrawer(open);
  }, [action, open, submitCandidate, updateMapping]);

  const setTabs = async (index: number) => {
    setLoader(true);
    setTabIndex(index);
    setMessage('');
    if (index === 6) {
      setSubmissionSettings();
    }
    setLoader(false);
  };
  useEffect(() => {
    const checkForJobPostingTeam = async () => {
      const teams = await getAllTeamsOfCurrentUser();

      const checkForJobPostingTeam = teams?.filter(
        (team) => team.id == state.candidate.jobPostedByTeam?.id
      );
      setIsPartOfTeam(isEmpty(checkForJobPostingTeam));
    };

    checkForJobPostingTeam;
  }, [state.candidate.jobPostedByTeam?.id]);

  useEffect(() => {
    if (mappingFormSettingsResponse.fields)
      setMappingFormSetings(mappingFormSettingsResponse.fields);
  }, [mappingFormSettingsResponse.fields]);

  const sx1 = {
    bgcolor: WsColors.White,
    borderRight: `2px solid ${WsColors.TertiaryShades500}`,
  };

  return (
    <WsDrawer
      open={openDrawer}
      style={{ zIndex: '1300' }}
      hideHeader={true}
      onClose={() => null}
      hideOverflow={true}
      size="large"
    >
      <Grid container direction="row" justifyContent="flex-end">
        <Grid item xs={3} sx={sx1}>
          {/* {workspace.id === '0ed56aea-54c9-4485-987f-ffb35872eb38' ||
          workspace.id === '352f4535-62a5-4d74-8019-cb2ea76d8cb5' ? ( */}
          <WidgetDrawerNavigationNew
            isMapped={isMapped}
            defaultValue={defaultIndex}
            getTabIndex={(index) => setTabs(index)}
            closeDrawer={() => {
              updateActivityConversation(null);
              setOpenDrawer(false);
              updateAction(null);
              closeDrawer();
            }}
          />
          {/* ) : (
            <WidgetDrawerNavigation
              isMapped={isMapped}
              defaultValue={defaultIndex}
              getTabIndex={(index) => setTabs(index)}
              closeDrawer={() => {
                updateActivityConversation(null);
                setOpenDrawer(false);
                updateAction(null);
                closeDrawer();
              }}
            />
          )} */}
        </Grid>
        {!successMessage ? (
          <GridItem item xs={9} sx={{ overflow: 'clip' }}>
            {tabIndex == 3 && (
              <Item sx={{ padding: 0 }}>
                <BulkEmail
                  candidates={[state.candidate]}
                  toEmailList={selectedEmail ? [selectedEmail] : []}
                  drawer={false}
                  defaultJob={selectedJob}
                  handleClose={() => {
                    closeDrawer();
                    // updateCandidate(state.candidate);
                  }}
                  amplitudeEventHandler={(eventType: string) => {
                    const amplitudeJobCrmTabs = {
                      ['Ai_Suggestions']: () =>
                        amplitudeEventJobCrmSmartSourceAiEmailSuccessFail[eventType](loggedInUser),
                      ['Similar_Jobs']: () =>
                        amplitudeEventJobCrmSmartSourceSimilarJobsEmailSuccessFail[eventType](
                          loggedInUser
                        ),
                      ['Mappings']: () =>
                        amplitudeEventJobCrmPipelineMappingEmailSuccessFail[eventType](
                          loggedInUser
                        ),
                      ['Submission']: () =>
                        amplitudeEventJobCrmPipelineSubmissionsEmailSuccessFail[eventType](
                          loggedInUser
                        ),
                      ['Uploaded']: () =>
                        amplitudeEventJobCrmPipelineUploadedEmailSuccessFail[eventType](
                          loggedInUser
                        ),
                      ['Application']: () =>
                        amplitudeEventJobCrmPipelineApplicationsEmailSuccessFail[eventType](
                          loggedInUser
                        ),
                    };
                    amplitudeJobCrmTabs[amplitudeJobCrmUrl() ?? '']();
                  }}
                />
              </Item>
            )}
            {tabIndex == 4 && state.candidate && (
              <Item sx={{ padding: 0, height: '100vh', overflowY: 'auto' }}>
                <SMSChatBox
                  candidate={state.candidate}
                  selectedJob={selectedJob}
                  receiverPhoneNumber={selectedPhoneNumber ?? ''}
                  amplitudeEventHandler={(eventType: string) => {
                    const amplitudeJobCrmTabs = {
                      ['Ai_Suggestions']: () =>
                        amplitudeEventJobCrmSmartSourceAiPhoneSuccessFail[eventType](loggedInUser),
                      ['Similar_Jobs']: () =>
                        amplitudeEventJobCrmSmartSourceSimilarJobsPhoneSuccessFail[eventType](
                          loggedInUser
                        ),
                      ['Mappings']: () =>
                        amplitudeEventJobCrmPipelineMappingsPhoneSuccessFail[eventType](
                          loggedInUser
                        ),
                      ['Submission']: () =>
                        amplitudeEventJobCrmPipelineSubmissionsPhoneSuccessFail[eventType](
                          loggedInUser
                        ),
                      ['Uploaded']: () =>
                        amplitudeEventJobCrmPipelineUploadedPhoneSuccessFail[eventType](
                          loggedInUser
                        ),
                      ['Application']: () =>
                        amplitudeEventJobCrmPipelineApplicationsPhoneSuccessFail[eventType](
                          loggedInUser
                        ),
                    };
                    amplitudeJobCrmTabs[amplitudeJobCrmUrl() ?? '']();
                  }}
                />
              </Item>
            )}
            {tabIndex == 5 && (
              <Grid item xs={12} display="flex" justifyContent="center" pt={12}>
                <WsTypography variant={WsTypoVariants.TITLE} color={WsTypoColors.SECONDARY}>
                  Coming Soon
                </WsTypography>
              </Grid>
            )}
            {tabIndex == 0 && (
              <Box>
                {isPartOfTeam ? (
                  <WsTypography variant={WsTypoVariants.SUB_TITLE} bold={true}>
                    Sorry, You cannot update submission as you are not part of job posting team !!
                  </WsTypography>
                ) : (
                  <>
                    {isEmpty(tempConv) ? (
                      <>
                        {/* {workspace.id === '0ed56aea-54c9-4485-987f-ffb35872eb38' ||
                        workspace.id === '352f4535-62a5-4d74-8019-cb2ea76d8cb5' ||
                        isLayout ? ( */}
                        <MappingFormNew
                          state={state}
                          recruiterAction={recruiterAction}
                          selectedJob={selectedJob}
                          closeDrawer={(candidate) => candidate && onCandidateUpdate(candidate)}
                          mappingFormSettings={mappingFormSettings}
                          isLayout={isLayout}
                          closeMap={closeMap}
                          mappingPurpose={mappingPurpose}
                        />
                        {/* ) : (
                          <MappingForm
                            state={state}
                            recruiterAction={recruiterAction}
                            selectedJob={selectedJob}
                            closeDrawer={(candidate) => candidate && onCandidateUpdate(candidate)}
                            mappingFormSettings={mappingFormSettings}
                          />
                        )} */}
                      </>
                    ) : (
                      <Stack mt={20} alignItems="center">
                        <WsTypography variant={WsTypoVariants.SUB_TITLE} bold={true}>
                          Candidate is recently mapped to this job
                        </WsTypography>
                      </Stack>
                    )}
                  </>
                )}
              </Box>
            )}

            {tabIndex == 7 && (
              <Box sx={{ borderLeft: `1px solid ${WsColors.TertiaryShades500}` }}>
                <SendRtrComponent state={state} closeWidgetDrawer={closeDrawer} isMapping={true} />
              </Box>
            )}
            {tabIndex == 6 && (
              <Box>
                <WsTaskCreationCard
                  closeDialog={() => null}
                  candidate={state.candidate}
                  selectedJob={selectedJob ?? {}}
                  showHeader={true}
                  interactionId={fromPage !== 'talentpool' ? widgetCandidate?.id ?? '' : ''}
                  handleClose={(isClose: boolean) =>
                    isClose
                      ? closeDrawer()
                      : setMessage(
                          'Your Reminder has been created successfully. You can do other actions like Email, SMS, Calls and Update using options on the Menu.'
                        )
                  }
                />
              </Box>
            )}
            {tabIndex == 8 && (
              <Box>
                {' '}
                {!loader && submissionSetting ? (
                  <Box sx={{ borderLeft: `1px solid #484D6D` }}>
                    <SubmissionForm
                      submissionSetting={submissionSetting}
                      state={state}
                      selectedJob={selectedJob}
                      submissionPurpose={submissionPurpose}
                      closeDrawer={closeDrawer}
                    />
                  </Box>
                ) : (
                  <Box textAlign="center">
                    <CircularProgress disableShrink sx={{ color: WsColors.TheBlues500 }} />
                  </Box>
                )}
              </Box>
            )}
            {tabIndex == 1 && !isEmpty(selectedJob?.questions) && (
              <RecruiterQuestionForm
                selectedJob={selectedJob}
                state={state}
                isMapped={isMapped || isRecentInteractionWithCurrentJob}
                candidateViewData={candidateViewData}
                closeDrawer={closeDrawer}
                questionAnswer={questionAnswer}
              />
            )}
            {tabIndex == 2 && (
              <div>
                <ShareCandidateOverlay
                  selectedJobData={selectedJob || null}
                  onClose={closeDrawer}
                  candidate={state.candidate}
                />
              </div>
            )}
          </GridItem>
        ) : (
          <Grid item xs={9} m={'Auto'} px={5}>
            <SuccessMessageLayout message={successMessage} />
          </Grid>
        )}
      </Grid>
    </WsDrawer>
  );
};

export default ConversationWidgetDrawer;
